import styled from 'styled-components'

export const StyledEditor = styled.div<{ $readOnly: boolean; $maxHeight?: string }>`
  .ql-font-roboto {
    font-family: Roboto, Helvetica, Arial, sans-serif;
  }

  .ql-font-roboto-condensed {
    font-family: 'Roboto Condensed', Helvetica, Arial, sans-serif;
  }

  .ql-font-lora {
    font-family: Lora, Helvetica, Arial, sans-serif;
  }

  .ql-picker.ql-font {
    width: 130px;

    .ql-picker-label[data-value='roboto']::before,
    .ql-picker-item[data-value='roboto']::before {
      content: 'Roboto';
      font-family: Roboto, Helvetica, Arial, sans-serif;
    }

    .ql-picker-label[data-value='roboto-condensed']::before,
    .ql-picker-item[data-value='roboto-condensed']::before {
      content: 'Roboto Cond.';
      font-family: 'Roboto Condensed', Helvetica, Arial, sans-serif;
    }

    .ql-picker-item[data-value='roboto-condensed']::before {
      content: 'Roboto Condensed';
    }

    .ql-picker-label[data-value='lora']::before,
    .ql-picker-item[data-value='lora']::before {
      content: 'Lora';
      font-family: Lora, Helvetica, Arial, sans-serif;
    }
  }

  .ql-container {
    font-family: ${({ theme }) => theme.fonts.textCondensedFont};
    color: ${({ theme }) => theme.colors.heading};
    font-size: 14px;
  }

  .ql-toolbar {
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.greyLight};
    padding: 8px;

    button:hover,
    .ql-picker-label:hover,
    button.ql-active,
    .ql-picker-label.ql-active {
      color: ${({ theme }) => theme.colors.violetLight};

      .ql-stroke {
        stroke: ${({ theme }) => theme.colors.violetLight};
      }

      .ql-fill {
        fill: ${({ theme }) => theme.colors.violetLight};
      }
    }

    .ql-picker-item:hover,
    .ql-picker-item.ql-selected {
      color: ${({ theme }) => theme.colors.violetLight};
    }
  }

  .ql-container {
    border: none;
  }

  .ql-editor {
    padding: ${({ $readOnly }) => ($readOnly ? '0' : '12px')};
    min-height: ${({ $readOnly }) => ($readOnly ? 'auto' : '150px')};
    max-height: ${({ $maxHeight }) => $maxHeight || 'unset'};
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.greyLight};
      border: 1px solid ${({ theme }) => theme.colors.bgDark};
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.colors.bgDark};
    }
  }

  .ql-editor.ql-blank::before {
    font-style: normal;
    color: ${({ theme }) => theme.colors.grey};
  }

  .ql-editor a {
    color: ${({ theme }) => theme.colors.violetLight};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`
